import { graphql } from "gatsby";
import PropTypes from "prop-types";
import React, { useEffect } from "react";

import "./subTopic.scss";

import BreadCrumb from "../../components/BreadCrumb/breadCrumb";
import Dropdown from "../../components/Dropdown/dropdown";
import Header from "../../components/Header/header";
import Section from "../../components/Section/section";
import TopicDesktop from "../../components/TopicDesktop/topicDesktop";
import { EVENTS, TEMPLATES } from "../../utils/constants";
import {
  ingestData,
  isMobile,
} from "../../bridges/BridgeServices";
import SearchInput from "../../components/SearchInput/searchInput";
import CTALabel from "../../components/CTALabel/ctaLabel";
import { isTokenPresent } from "../../utils/cookieHelper";
import MobileHeader from "../../components/MobileHeader/mobileHeader";
import { isShowWebHeader } from "../../utils/helperFunctions";

const SubTopic = ({
  data: { wpPage: { uri = "" } = {} },
  pageContext: {
    allPagesData = {},
    searchDataArrayObject = [],
  },
}) => {
  const {
    parentUri = "",
    "child-pages": childPages = [],
    seoTitle,
    seoMetaDesc,
    ctaDetails,
    title = "",
  } = allPagesData[uri] || {};

  const { "child-pages": siblingPages } =
    allPagesData[parentUri] || {};

  let sectionChildPages = [];
  let faqChildPages = [];

  for (let child of childPages) {
    const { templateName = "" } = allPagesData[child] || {};
    if (templateName === TEMPLATES.FAQ) {
      faqChildPages.push(child);
    }
    if (templateName === TEMPLATES.SECTION) {
      sectionChildPages.push(child);
    }
  }

  useEffect(() => {
    if (isMobile)
      ingestData({
        name: EVENTS.FAQ_SUBCATEGORY_LOADED,
      });
  }, []);
  return (
    <div className="sub-topic">
      <Header
        title={seoTitle}
        description={seoMetaDesc}
        searchData={searchDataArrayObject}
        pageURI={uri}
      />
      <div className="sub-topic-dropdown">
        {/* adding an extra div for server side rendering */}
        <div className="mobile-search-input-wrapper">
          {isMobile() ? (
            isShowWebHeader() ? (
              <MobileHeader
                variant="compressed"
                faqTitle={title}
              />
            ) : (
              <SearchInput data={searchDataArrayObject} />
            )
          ) : null}
        </div>
        <BreadCrumb uri={uri} allPagesData={allPagesData} />

        <Dropdown
          pages={siblingPages}
          allPagesData={allPagesData}
          activeUri={uri}
        />
        <Section
          sectionPages={faqChildPages}
          allPagesData={allPagesData}
        />
        <Section
          sectionPages={sectionChildPages}
          allPagesData={allPagesData}
        />
      </div>
      <TopicDesktop uri={uri} allPagesData={allPagesData} />
      {ctaDetails && isMobile() && isTokenPresent() && (
        <CTALabel faqTitle={title} {...ctaDetails} />
      )}
    </div>
  );
};

SubTopic.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object,
};

export default SubTopic;

export const query = graphql`
  query SubTopicPageById($id: String!) {
    wpPage(id: { eq: $id }) {
      uri
    }
  }
`;
